(function () {
    'use strict';

    angular
        .module('cog.shared')
        .factory('HttpRequestService', HttpRequestService);

    /* @ngInject */
    function HttpRequestService($http, $state, notificationService: INotificationService, appSettings, $q, localStorageService, $filter, $rootScope, $window) {
        var service: IHttpRequestService = {
            getData: getData,
            postData: postData,
            hasError: hasError,
        };
        return service;

        //////////// 

        function getData(url) {
            var defer = $q.defer();
            $http.get(url).then(function (response) {
                if (!hasError(defer, response, 'Getting data Failed '))
                    defer.resolve(response.data);
            }, function (error) {
                hasError(defer, error, 'Getting data Failed ');
            });
            return defer.promise;
        }

        function postData(url, data) {
            var defer = $q.defer();
            $http.post(url, data).then(function (response) {
                if (!hasError(defer, response, 'Post data Failed '))
                    defer.resolve(response.data);
            }, function (error) {
                hasError(defer, error, 'Post data Failed ');
            });

            return defer.promise;
        }

        function hasError(defer, response, msg) {
            var ok = true;
            if (response.status == '401') {
                //$state.go('bmauth.login');
                /*
                var is_bm = localStorageService.get('isBM');
                var isBM: boolean =  (is_bm != null) ? is_bm : false;
                if (isBM) {
                    $state.go('bmauth.login');
                } else {
                    $state.go('authentication.login');
                }
                */
                $rootScope.$broadcast('statusRequireAuth');
                $window.location.assign("/");
            } else if (response.status != '200') {
                notificationService.displayError(msg);
                defer.reject(response);
            } else ok = false;
            return ok;
        }
    }
})();